/** zh-CN catalogue `publish` (W3-09; English: src/features/publish/publish.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'publish',
  locale: 'zh-CN',
  messages: {
    panelOverview: '检查',
    panelPackage: '打包与导出',
    noProjectTitle: '没有打开的谱面',
    noProjectBody: '打开一张谱面，即可检查它并为 Phira 导出。',
    checkTitle: '检查',
    checkAgain: '重新检查',
    sevFatal: '{count, plural, =0 {没有会导致 Phira 无法加载谱面的问题} other {有 # 个问题会导致 Phira 无法加载谱面}}',
    sevError: '{count, plural, =0 {没有错误} other {# 个错误}}',
    sevWarning: '{count, plural, =0 {没有警告} other {# 个警告}}',
    sevTip: '{count, plural, =0 {没有提示} other {# 条提示}}',
    view: '查看',
    viewIn: '在“问题”面板中显示{severity, select, fatal {阻止导出的问题} error {错误} warning {警告} other {提示}}',
    viewBlocking: '显示阻止导出的问题',
    severityWord: '{severity, select, fatal {阻止导出} error {错误} warning {警告} other {提示}}',
    blockingTitle: '导出前请修复',
    topTitle: '最重要的问题',
    moreInProblems: '“问题”面板中还有 {count, plural, other {# 个}}',
    go: '转到',
    goTo: '转到问题：{message}',
    compatTitle: '兼容性',
    phiraName: 'Phira',
    rpeName: 'RPE 1.6 及更高版本',
    phiraOk: '渲染效果与预览一致',
    phiraOkNotes: '渲染效果与预览一致。注意：',
    phiraBlockedStatus: '暂时无法加载谱面',
    phiraDiffers: '播放效果与预览不同',
    rpeOk: '能打开谱面包',
    rpeOkNotes: '能打开谱面包。{count, plural, other {# 条注意事项}}：',
    unverified: '未验证',
    unverifiedTip:
      'RPE 兼容的谱面包尚未在真实安装的 RPE 上检查过。它严格遵循 RPE 格式，但 RPE 本身仍可能有细节显示不同。',
    phiraBlocked: '有 {count, plural, other {# 个问题}}会导致 Phira 无法加载谱面（见“检查”）。',
    noteBezierCollisions:
      '有 {curves, plural, other {# 条贝塞尔曲线}}与另一条曲线取整后的缓存键相同，因此 Phira 对 {events, plural, other {# 个事件}}使用第一条曲线。预览中已按此方式显示。',
    rpeNoInfoTxt: '没有写入 info.txt（精简配置，或已在“高级”中关闭），因此 RPE 无法自行导入谱面包。',
    rpeEasings:
      '有 {count, plural, other {# 个区段}}使用了“过冲，两端慢”（23）或“弹簧，两端慢”（29），RPE 绘制它们的方式与 Phira 不同。',
    rpeBezierHandles:
      '有 {count, plural, other {# 条贝塞尔曲线}}的控制柄超出 0 到 1 的范围（导入的）。Phira 能播放，但 RPE 的曲线编辑器可能无法处理。',
    rpeNoteFields:
      '有 {count, plural, other {# 个音符}}使用了音符颜色或判定宽度，这需要 RPE 1.7。旧版 RPE 会丢弃它们。',
    rpeSpeedCurves: '“RPE 1.7 流速曲线”已开启：带缓动的流速只在 RPE 1.7 或更高版本中看起来相同。',
    rpeRotateWithParent: '有 {count, plural, other {# 条子线}}随父线旋转，这需要 RPE 1.6.3 或更高版本。',
    rpeLayers: '有 {count, plural, other {# 条判定线}}使用了超过 4 个层级；RPE 只显示前 4 个。',
    rpeExtraJson:
      '着色器特效和视频（{effects, plural, other {# 个特效}}，{videos, plural, other {# 个视频}}）只适用于 Phira；RPE 会忽略 extra.json。',
    rpeMusicCodec: 'RPE 无法打开 {codec} 音乐。请为 RPE 将曲目转换为 WAV、OGG 或 MP3。',
    rpeImageCodec: 'RPE 可能无法显示 {codec} 曲绘。PNG 或 JPG 是最稳妥的选择。',
    statsTitle: '统计',
    statsNotes: '{notes, plural, other {# 个音符}}（{real} 个真键，{fake} 个假键）',
    statsLines: '{count, plural, other {# 条判定线}}',
    statsKeys: '{count, plural, other {# 个关键帧}}',
    statsLength: '时长 {length}',
    statsNeverExported: '尚未导出',
    statsChanged: '上次导出（{name}，{when}）后有更改',
    statsUnchanged: '上次导出（{name}，{when}）后没有更改',
    timeJustNow: '刚刚',
    timeMinutes: '{n, plural, other {# 分钟}}前',
    timeHours: '{n, plural, other {# 小时}}前',
    timeDays: '{n, plural, other {# 天}}前',
    packageTitle: '谱面包',
    fieldName: '曲名',
    fieldLevel: '难度标签',
    fieldLevelHelp: '显示在选曲界面中，例如“IN Lv.15”。',
    fieldDifficulty: '难度',
    fieldCharter: '谱师',
    fieldComposer: '曲师',
    fieldIllustrator: '画师',
    fieldPreview: '选曲预览',
    previewFrom: '从',
    previewTo: '到',
    previewHelp: 'Phira 在选曲界面中播放的曲目片段。',
    playPreview: '播放预览',
    stopPreview: '停止预览',
    previewNoSong: '曲目尚未加载。',
    previewProblem:
      '{problem, select, negativeStart {预览在曲目开始之前就开始了。} endBeforeStart {预览的结束早于开始。} other {预览在曲目（{song} 秒）结束之后才结束。}}Phira 会拒绝打开谱面。',
    fieldTags: '标签',
    division: '分区',
    divisionHelp: 'Phira 会把谱面归入这些分区。',
    divRegular: 'Regular',
    divVisual: 'Visual',
    divTroll: 'Troll',
    divPlain: 'Plain',
    divNone: '无',
    tagList: '谱面的标签',
    addTag: '添加标签',
    addTagPlaceholder: '输入新标签后按 Enter',
    removeTag: '移除标签 {tag}',
    fieldIntro: '简介',
    fieldTip: '提示语',
    tipPlaceholder: '谱面加载时显示（可选）',
    illustrationAlt: '{name} 的曲绘',
    noIllustration: '没有曲绘',
    changeIllustration: '更换图片…',
    txnEditField:
      '编辑{field, select, name {曲名} level {难度标签} difficulty {难度} charter {谱师} composer {曲师} illustrator {画师} preview {选曲预览} tags {标签} intro {简介} other {提示语}}',
    txnEditPkg: '更改导出的{field, select, profile {配置} other {文件名}}',
    txnClampPreview: '将选曲预览移到曲目范围内',
    exportTitle: '导出',
    exportTarget: '导出为',
    targetPez: 'Phira / RPE 谱面包（.pez）',
    targetPezHelp: '包含 Phira 所需的一切。直接在 Phira 中导入即可。除非你在“高级”中添加，否则不包含编辑器数据。',
    targetChart: '仅谱面文件（chart.json）',
    targetChartHelp: '供其他工具使用的纯谱面：不含曲目、图片或谱面包设置。',
    targetBackup: '项目备份',
    targetBackupHelp: '谱面包加上编辑器数据（phiedit.json）和所有文件，包括未使用的文件。',
    exportButton: '导出…',
    copyChart: '复制 chart.json',
    advanced: '高级',
    profile: '配置',
    profileRpe: 'RPE 兼容',
    profileMinimal: '精简（仅 Phira）',
    profileHelp:
      'RPE 兼容会填充编辑器创建的判定线并写入 info.txt，让 RPE 以相同方式打开谱面；精简只写入 Phira 需要的内容。',
    naming: '文件名',
    namingReadable: '易读（chart.json、music.ogg）',
    namingRpe: 'RPE ID（{id}.json）',
    namingRpeNoId: 'RPE ID（谱面没有 ID）',
    namingRpeUnavailable: '谱面没有数字 RPE ID，因此文件保留易读的名称。',
    rpeVersion: 'RPE 版本',
    rpeVersionProject: '项目（{version}）',
    rpeVersionHelp: '仅在本次会话的导出中写为 RPEVersion；项目保持 {version}。',
    speedModeValue: '流速：{mode}',
    speedClassic: '经典',
    speed170: 'RPE 1.7 流速曲线',
    speed170Legacy: 'RPE 1.7 流速曲线，旧公式（RPE 版本 {version}）',
    speedHelp: '流速模式在“项目设置”中修改。',
    openProjectSettings: '项目设置…',
    includeSidecar: '包含编辑器数据（phiedit.json）',
    includeSidecarHelp:
      '再次导入谱面包时，层级名称、颜色标签、已忽略的问题和其他仅编辑器数据会恢复。Phira 会忽略该文件。',
    backupIncludes: '项目备份始终包含它。',
    includeInfoTxt: '为 RPE 包含 info.txt',
    includeUnused: '包含未使用的文件',
    pretty: '缩进的 JSON',
    floatStyle: '数字',
    floatRpe: 'RPE 风格（1.0）',
    floatShortest: '最短（1）',
    dialogTitle: '导出',
    fileName: '文件名',
    destination: '保存到',
    destDownload: '下载文件夹',
    destSaveAs: '选择保存位置',
    destSaveAsUnavailable: '此浏览器无法询问保存位置；文件会保存到下载文件夹。',
    preflight: '导出前检查',
    blockingCount: '{count, plural, =0 {没有阻止导出的问题} other {有 # 个问题阻止导出}}',
    notesCount: '{count, plural, =0 {没有转换说明} other {# 条说明}}',
    written: '写入内容',
    writtenLine: 'format rpe · RPEVersion {version} · useRpe170Speed {speed} · useAttachUiFix {fix}',
    writtenChartOnly: 'format rpe · RPEVersion {version} · 无 info.yml（仅谱面文件）',
    output: '输出',
    outputFile: '{name}（{size}）',
    outputFileUnknown: '{name}',
    outputTotal: '总计约 {size}',
    calculating: '正在计算大小…',
    missingNotWritten: '缺失，未写入：{files}',
    switchesTitle: '没有 info.yml 时，Phira 的播放效果会有以下不同：',
    copySwitchesTitle: '复制 chart.json：没有 info.yml 时，Phira 播放复制的谱面会有以下不同：',
    copyNoSwitches: '没有：没有 info.yml 时，复制的谱面播放效果相同。',
    chartOnlyScope: '单独的谱面文件不包含曲目、文件、文件名或选曲预览，因此对它们的检查不会阻止导出。',
    noSwitches: '没有：没有 info.yml 时，谱面播放效果相同。',
    bakeSpeed: '为此文件将流速烘焙为线性',
    bakeSpeedHelp: '带缓动的流速会变为线性分段，使单独的 chart.json 在 Phira 默认流速公式下播放效果相同。',
    exportAnyway: '仍然导出…',
    exportAnywayTitle: '带着问题导出？',
    exportAnywayBody:
      '有 {count, plural, other {# 个问题}}会导致 Phira 无法加载此谱面。在修复之前，该文件无法在 Phira 中打开。',
    exportAnywayConfirm: '仍然导出',
    checkingChart: '正在检查谱面…',
    waitingForCheck: '正在等待检查完成…',
    checkPendingTitle: '在检查完成之前导出？',
    checkPendingBody: '谱面检查仍在运行，因此可能还没有列出会导致 Phira 无法加载谱面的问题。',
    export: '导出',
    cancel: '取消',
    close: '关闭',
    running: '正在导出…',
    progressLabel: '导出进度',
    selfCheckFailedTitle: '导出的文件与谱面不一致',
    selfCheckFailedBody:
      '读回文件得到了不同的谱面。这是导出器的错误，该文件的播放效果可能与预览不同。请连同下方的详情报告此问题。',
    details: '详情',
    copyDetails: '复制详情',
    saveAnyway: '仍然保存…',
    saveAnywayTitle: '保存未通过检查的文件？',
    saveAnywayBody: '该文件与谱面不一致，在 Phira 中的播放效果可能与预览不同。',
    saveAnywayConfirm: '仍然保存',
    warnedTitle: 'Phira 播放此文件的效果会与预览不同',
    warnedBody: '文件与谱面一致，但导出设置会改变 Phira 播放它的方式。',
    saveWarnedTitle: '保存一个在 Phira 中播放效果不同的文件？',
    saveWarnedBody: '与预览相比，导出设置会改变 Phira 播放此谱面的方式。',
    emptyTitle: '无法写入谱面',
    emptyBody: '导出器拒绝了谱面（编辑器的错误）。没有保存任何内容。请连同下方的详情报告此问题。',
    errorTitle: '导出失败',
    unsavedWarning: '存储尚未确认最新的更改；导出内容与你在编辑器中看到的一致。',
    toastExported: '已导出 {name}（{size}）。在 Phira 中：选择“导入”，然后选取此文件。',
    toastExportedChart: '已保存 {name}（{size}）。',
    toastExportedBackup: '已保存备份：{name}（{size}）。',
    toastCopied: '已将 chart.json 复制到剪贴板（{size}）。',
    toastCopiedNoted:
      '已将 chart.json 复制到剪贴板（{size}）。没有 info.yml 时，Phira 的播放效果会不同（{count, plural, other {# 项设置}}，列在“复制 chart.json”下）。',
    toastCopiedSwitches:
      '没有 info.yml 时，Phira 播放此谱面的效果会不同（{count, plural, other {# 项设置}}）。导出对话框在“复制 chart.json”下列出了它们。',
    showSwitches: '显示',
    toastCopyFailed: '浏览器不允许复制到剪贴板。',
    toastSaveFailed: '无法保存文件：{error}',
    toastDetailsCopied: '已复制详情。',
    txnRecordExport: '导出 {name}',
    savePickerDescription: '{target, select, chartJson {RPE 谱面} other {Phira 谱面包}}',
    untitled: '未命名',
    sizeB: '{size} B',
    sizeKB: '{size} kB',
    sizeMB: '{size} MB',
    sizeGB: '{size} GB',
    blockNoMusic: '谱面没有曲目。',
    blockNoMusicWhy: '没有可解码的曲目时，Phira 无法加载谱面。',
    blockMusicMissing: '曲目“{path}”缺失。',
    blockMusicUndecodable: 'Phira 无法解码曲目“{path}”（{codec}）。',
    blockFileMissing: '谱面使用了文件“{path}”，但它缺失了。',
    blockFileUndecodable: 'Phira 无法解码“{path}”（{codec}）。',
    blockFileWhy: '所需的文件缺失或无法读取时，Phira 无法加载谱面。',
    blockGifOnImage: '判定线“{line}”有 GIF 进度，但其图片不是 GIF。',
    blockGifOnImageWhy: 'Phira 无法加载谱面：其 GIF 解码器无法读取该图片。',
    blockPreview:
      '{problem, select, negativeStart {选曲预览在曲目开始之前就开始了。} endBeforeStart {选曲预览的结束早于开始（{start} 秒到 {end} 秒）。} other {选曲预览（{start} 秒到 {end} 秒）在曲目（{song} 秒）结束之后才结束。}}',
    blockPreviewWhy: '选曲预览超出曲目范围时，Phira 会拒绝打开谱面。',
    fixAddMusic: '添加曲目…',
    fixChooseFile: '选择文件…',
    fixClampPreview: '移到曲目范围内',
    fixEditPreview: '编辑预览',
    cmdExport: '导出…',
    cmdCopyChart: '复制 chart.json',
    cmdPlayPreview: '播放选曲预览',
    cmdClampPreview: '将选曲预览移到曲目范围内',
    cmdDetails: '编辑谱面信息（曲名、难度标签、谱师）',
    cmdFocusField: '转到某项谱面信息',
    argField: '信息',
    reasonNoProject: '请先打开一张谱面。',
    reasonPreviewOk: '选曲预览已经在曲目范围内。',
    reasonNoSong: '曲目的时长尚未知晓。',
    settingDestination: '导出文件保存到',
    settingDestinationHelp: '下载文件夹，或会记住文件夹的保存对话框（Chrome 和 Edge）。',
    settingSidecar: '在谱面包中包含编辑器数据（phiedit.json）',
    settingSidecarHelp: '再次导入谱面包时，会恢复层级名称、颜色标签和其他仅编辑器数据。Phira 会忽略该文件。',
    settingInfoTxt: '为 RPE 写入 info.txt（RPE 兼容配置）',
    settingUnused: '在谱面包中包含未使用的文件',
    settingPretty: '写入缩进的 JSON',
    settingFloat: '导出 JSON 中的数字风格',
    helpTitle: '发布到 Phira',
    helpBody:
      '打开**发布** [[app.workspace workspace=publish]]，查看谱面是否已准备就绪：会导致 Phira 无法加载的问题、Phira 和 RPE 如何显示它，以及玩家在选曲界面中看到的谱面包信息。\n\n按**导出** [[file.export]]。在对话框中按 Enter 会以你上次的设置开始导出。编辑器会在保存前读回每个导出的文件，并与谱面进行比较。.pez 文件包含谱面、曲目、图片和 info.yml。\n\n在 Phira 中：选择“导入”，然后选取 .pez 文件，即可在手机或电脑上游玩。',
    blockFileStoredMissing: '此浏览器的存储中缺少文件“{path}”。',
    blockSongStoredMissing: '此浏览器的存储中缺少曲目“{path}”。',
    blockStoredMissingWhy: '谱面仍列出了该文件，但浏览器中已没有它，因此无法将其写入谱面包。再次选择同一文件即可恢复。',
    calculatingNotes: '正在检查转换…',
    chooseIllustration: '选择图片…',
    chooseIllustrationAgain: '重新选择…',
    copyNoticeSummary:
      '{count, plural, =0 {复制 chart.json：没有 info.yml 时播放效果相同} other {复制 chart.json：没有 info.yml 时在 Phira 中有 # 处不同}}',
    exportFileLost:
      '此浏览器的存储中缺少文件“{name}”，因此无法将其放入谱面包。请在“素材”中重新选择同一文件，然后再次导出。',
    exportFileLostAny: '此浏览器的存储中缺少谱面的某个文件，因此无法将其放入谱面包。请打开“素材”重新选择它。',
    filesLabel: '文件',
    fixChooseAgain: '重新选择文件…',
    illustrationFailed: '无法显示图片',
    illustrationMissing: '此浏览器的存储中缺少该图片',
    kindChart: '谱面',
    kindOthers: '{count, plural, other {另外 # 个文件}}',
    kindPicture: '图片',
    kindSidecar: '编辑器数据',
    kindSong: '曲目',
    noteApproxEffects:
      'Phira 会用自己的着色器绘制{count, plural, =1 {内置特效} other {这些内置特效}} {names}；预览显示的是近似效果。',
    outputFileEstimated: '{name}（约 {size}，上次导出）',
    outputSummary: '写入{files}，约 {size}。',
    outputSummaryNoSize: '写入{files}。',
    phiraOkExceptEffects: '{count, plural, other {除 # 个内置特效（近似）外，渲染效果与预览一致}}。注意：',
    profileRpeUnverified: 'RPE 兼容（未验证）',
    sizesAfterExport: '第一次导出后才能知道谱面的大小。',
    cmdRpeChecklist: '生成 RPE 检查清单包（验证 RPE 兼容配置）',
    toastRpeChecklist: '已保存 {name}：打开其中的 CHECKLIST.txt，并在 RPE 中逐项完成。',
    toastRpeChecklistFailed: '无法生成 RPE 检查清单包：{error}',
  },
};

export default catalog;
